import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import ReactDOMServer from 'react-dom/server';

export const reactRenderToStaticHTML = (element, theme) => ReactDOMServer.renderToStaticMarkup(<StyledEngineProvider injectFirst>
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
</StyledEngineProvider>);

export default reactRenderToStaticHTML;
